"use client";

import React from "react";
import Link from "next/link";

const AllOn6Cost: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Does Full Mouth Dental Implant Treatment Cost in Astoria?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          The{" "}
          <Link
            href="/blog/what-is-the-cost-of-full-mouth-dental-implants/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            cost of treatment
          </Link>{" "}
          depends on several factors:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Treatment type:</strong> Whether All-on-4 or All-on-6 is
            recommended
          </li>
          <li>
            <strong>Bone grafting:</strong> Whether additional bone support is
            required
          </li>
          <li>
            <strong>Prosthetic design:</strong> The material and construction
            of your arch
          </li>
          <li>
            <strong>Extractions:</strong> The complexity of any teeth that need
            removal
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          We provide transparent, detailed pricing before you commit to
          anything. Financing options are available, including extended
          no-interest payment plans. We&apos;ll also help you understand what
          your insurance may cover; no surprises.
        </p>
      </div>
    </section>
  );
};

export default AllOn6Cost;
